// optimus_vehicle_state enum + colors, mirrored from the optimus dashboard's engine-states so the
// road-test state graph reads the same as the main app.
export const ENGINE_STATES = [
    { state: 0, label: 'Key OFF', color: '#3a393e' },
    { state: 1, label: 'Initializing', color: '#6897b7' },
    { state: 2, label: 'Diesel', color: '#095587' },
    { state: 3, label: 'Biodiesel Warmup', color: '#7cb73d' },
    { state: 4, label: 'Biodiesel', color: '#0f7439' },
    { state: 5, label: 'Operational Purge', color: '#cf3034' },
    { state: 6, label: 'Vector Purge', color: '#f46522' },
    { state: 7, label: 'OTA Updating', color: '#fbb811' }
]

export const engineStateLabel = (state) => ENGINE_STATES.find(e => e.state === state)?.label ?? `State ${state}`

export const engineStateColor = (state) => ENGINE_STATES.find(e => e.state === state)?.color ?? '#8a929d'
